"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Restaurant;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Restaurant(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("style", {
    dangerouslySetInnerHTML: {
      __html: ".cls-1{fill:#231f20;}"
    }
  })), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Facilities"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "restaurant"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    id: "outline"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M46.453,7.5a2.5,2.5,0,0,0-2.5,2.5V27.98a6.486,6.486,0,1,1-12.971,0V10a2.5,2.5,0,0,0-5,0V27.98a11.5,11.5,0,0,0,8.694,11.128V90a2.5,2.5,0,0,0,5,0V39.248A11.5,11.5,0,0,0,48.953,27.98V10A2.5,2.5,0,0,0,46.453,7.5Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M37.4,30.48a2.5,2.5,0,0,0,2.5-2.5V10a2.5,2.5,0,0,0-5,0V27.98A2.5,2.5,0,0,0,37.4,30.48Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    className: "cls-1",
    d: "M73.885,33.349C72.1,12.2,63.183,8.076,62.171,7.676A2.5,2.5,0,0,0,58.75,10V90a2.5,2.5,0,0,0,5,0V57.9l.012.01a2.5,2.5,0,0,0,3.517-.359A35.608,35.608,0,0,0,73.885,33.349ZM63.75,53.917V15.835C65.784,18.867,68.1,24.3,68.9,33.769A31.523,31.523,0,0,1,63.75,53.917Z"
  })))));
}